class AnchorScroll {
    constructor(){
        document.querySelectorAll('a[href*="#"]')?.forEach(function(anchor){
            console.log(anchor.href)
            anchor.addEventListener('click', function(e){

                
                let href = anchor.getAttribute('href');
                console.log(href)
                if (href === "#"){return;}
                
                const [linkWithoutHash, anchorHref] = href.split('#');
                const currentPath = window.location.pathname;
                console.log(linkWithoutHash);
                console.log(currentPath)

                if (!anchorHref) return;
                if (linkWithoutHash && linkWithoutHash !== currentPath) {
                    return;
                }
                let target = document.getElementById(anchorHref);
                
                if (target){
                    let offsetTop = getOffsetTop(target);
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    })
                }
                e.preventDefault();
                return false;
            });
        })
        function getOffsetTop(element) {
            const rect = element.getBoundingClientRect();
            let header = document.querySelector('.header');
            if (header && (header.classList.contains('fixed') || header.classList.contains('tricky'))){
                return rect.top + window.scrollY - header.clientHeight;
            }
            return rect.top + window.scrollY;
        }
    }

}

export default AnchorScroll;